
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Dashboard/Dashboard.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Dashboard.html');
        
        var script = require('./Dashboard.ts').default;
        module.exports = require('./Dashboard.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    